import React from "react";
import Header from "components/Common/Header";
import Footer from "components/Common/Footer";

export default function DashboardManage(props) {
  return (
    <>
      <Header />
      <main className="main-content">
        <div className="dashboard-col-2">
          <div className="document-bar">{props.children}</div>
        </div>
      </main>

      <Footer />
    </>
  );
}
